<template>
    <div id="dashboard-main">
        <div class="quote-page">
            <div class="quote-card">

                <!-- 顶部报价类型切换 -->
                <div class="quote-type">
                    <div v-for="item in quoteTypes" :key="item.value"
                        :class="['type-item', activeType === item.value ? 'active' : '']"
                        @click="handleChange(item.value)">
                        <div class="type-title">{{ item.label }}</div>
                        <div class="type-desc">{{ item.desc }}</div>
                    </div>
                </div>

                <!-- 表单区域动画 -->
                <div class="form-wrapper">
                    <transition :name="transitionName">
                        <component :is="currentComponent" :key="activeType" @switching="handleChange"   />
                    </transition>
                </div>

            </div>

        </div>
    </div>
</template>


<script setup>
    import { ref, reactive, defineAsyncComponent, computed } from 'vue'
    import { ElMessage, FormInstance, FormRules } from 'element-plus'
    import { useRouter, useRoute } from 'vue-router';
    
    const route = useRoute();
    const router = useRouter();
    
    const rapid = defineAsyncComponent(() => import('@/components/quotation/rapid.vue'));
    const standard = defineAsyncComponent(() => import('@/components/quotation/standard.vue'));
    const precise = defineAsyncComponent(() => import('@/components/quotation/precise.vue'));

    const rapidRef = ref(null)
    const standardRef = ref(null)
    const preciseRef = ref(null)
    /* ===== 报价类型 ===== */
    const activeType = ref('quick')
    const transitionName = ref('slide-left')
    const currentStep = ref(1)
    const amountNumber = ref(6782342345)
    const componentMap = {
        quick: rapid,
        standard: standard,
        precise: precise
    }
    const quoteTypes = [
        {
            label: '快速估算',
            value: 'quick',
            desc: '适用于快速估算粗浅报价， 输入基本信息即可获得估算报价'
        },
        {
            label: '标准报价',
            value: 'standard',
            desc: '适用于计算市场报价， 输入楼层设备信息即可得出报价'
        },
        {
            label: '精准报价',
            value: 'precise',
            desc: '报价更精准、价格更优惠， 需联系专业人员进行测算'
        }
    ]
    const currentComponent = computed(() => {
        return componentMap[activeType.value]
    })
    const typeOrder = ['quick', 'standard', 'precise']
    const handleChange = (newType) => {
        if (!sessionStorage.getItem('token')){
            ElMessage.error('请先登录！');
            router.replace('/login');
        }
        const oldIndex = typeOrder.indexOf(activeType.value)
        const newIndex = typeOrder.indexOf(newType)
        console.log('oldIndex:', oldIndex, 'newIndex:', newIndex);

        transitionName.value =
            newIndex > oldIndex ? 'slide-left' : 'slide-right'

        activeType.value = newType
    }
</script>

<style scoped>
    .quote-page {
        display: flex;
        justify-content: center;
    }

    .quote-card {
        width: 100%;
        padding: 10px 60px;
    }

    /* ===== 顶部类型选择 ===== */
    .quote-type {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
    }

    .type-item {
        width: 30%;
        border: 1px solid #dcdfe6;
        border-radius: 8px;
        padding: 20px;
        text-align: center;
        cursor: pointer;
        transition: all 0.3s;
        background: #fff;
    }

    .type-item:hover {
        border-color: #409eff;
    }

    .type-item.active {
        background: #409eff;
        color: #fff;
        border-color: #409eff;
    }

    .type-title {
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 8px;
    }

    .type-desc {
        font-size: 13px;
        opacity: 0.8;
    }

    .form-wrapper {
        position: relative;
    }

    .form-wrapper>* {
        position: absolute;
        width: 100%;
        top: 0;
        left: 0;
    }



    /* ===== 左滑 ===== */
    .slide-left-enter-from {
        transform: translateX(100%);
        opacity: 0;
    }

    .slide-left-enter-to {
        transform: translateX(0);
        opacity: 1;
    }

    .slide-left-leave-from {
        transform: translateX(0);
        opacity: 1;
    }

    .slide-left-leave-to {
        transform: translateX(-100%);
        opacity: 0;
    }

    /* ===== 右滑 ===== */
    .slide-right-enter-from {
        transform: translateX(-100%);
        opacity: 0;
    }

    .slide-right-enter-to {
        transform: translateX(0);
        opacity: 1;
    }

    .slide-right-leave-from {
        transform: translateX(0);
        opacity: 1;
    }

    .slide-right-leave-to {
        transform: translateX(100%);
        opacity: 0;
    }

    /* 动画时长 */
    .slide-left-enter-active,
    .slide-left-leave-active,
    .slide-right-enter-active,
    .slide-right-leave-active {
        transition: transform 0.35s cubic-bezier(.4, 0, .2, 1);
        will-change: transform;
    }
</style>